export default __webpack_public_path__ + "static/media/alcibiades.e17a0bdf.webp";